import TextOverflow from './TextOverflow';

export default TextOverflow;
